import { render, staticRenderFns } from "./section-stone.vue?vue&type=template&id=40641535&"
import script from "./section-stone.vue?vue&type=script&lang=js&"
export * from "./section-stone.vue?vue&type=script&lang=js&"
import style0 from "./section-stone.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports